/**************************************************
 * Nombre:       FilaDatos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {obtenerCasilla} from "./obtenerCasilla";

const FilaDatos = ({item, datosCabecera}) => {


    return  datosCabecera.map((it, index) => {
        return obtenerCasilla({cabecera: it, datos: item})
    })


}
export default FilaDatos